import { API_BASE } from './env';

export const ORCHESTRATOR_CONFIG = {
  ENDPOINTS: {
    // E2E Taxonomy Orchestrator Endpoints
    FILE_SUMMARIZATION: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/custom-diagram-content/`,
    FILE_EVALUATION: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/diagram-file-conflict/`,
    PROCESS_INFO_EXTRACTION: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/create-process-info/`,
    BPMN_DIAGRAM_GENERATION: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/generate-diagram/flow/`,
    SOLUTION_GENERATION: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/ideation-to-diagram/bpmn/`,
    HANDLE_NEXT: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/handle-next/`,
    TAXONOMY_EVALUATE_DATA: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/evaluate-data/`,
    OPPORTUNITY_REPORT_EVALUATE_DATA: `${API_BASE}/api/v1/e2e_taxonomy/orchestrator/opportunity-report-evaluate-data/`,

    // Simulation Orchestrator Endpoints
    AGENT_CLASSIFICATION: `${API_BASE}/api/v1/simulation/orchestrator/solution-details/`,
    AGENT_AI_ENABLEMENT: `${API_BASE}/api/v1/simulation/orchestrator/ai-enablement/`,
    REGENERATE_BPMN: `${API_BASE}/api/v1/simulation/orchestrator/regenerate-bpmn/`,
    SEND_TO_SOLUTION: `${API_BASE}/api/v1/simulation/orchestrator/send-to-solution/`,

    // Ideation Orchestrator Endpoints
    EVALUATE_DATA: `${API_BASE}/api/v1/ideation/orchestrator/evaluate-data/`,
    USE_CASE_DATA: `${API_BASE}/api/v1/ideation/orchestrator/use-case-data/`,

    // New Solution Orchestrator Endpoints
    CURRENT_PROCESS: `${API_BASE}/api/v1/new-solution/solution-requirements/current-process/`,
    GENERATE_ELABORATED_SUMMARY: `${API_BASE}/api/v1/new-solution/solution-requirements/generate-elaborated-summary/`,
    CREATE_DATA_SOURCE: `${API_BASE}/api/v1/new-solution/solution-requirements/create-data-source/`,
    GENERATE_DETAILED_REPORT: `${API_BASE}/api/v1/new-solution/solution-requirements/generate-detailed-report/`,
    EVALUATE_SOLUTION_REQUIREMENTS: `${API_BASE}/api/v1/new-solution/solution-requirements/evaluate-solution-requirements/`,
    EVALUATE_AI_SOLUTION_BLUEPRINT: `${API_BASE}/api/v1/new-solution/solution-requirements/evaluate-ai-solution-blueprint/`,
    NEW_SOLUTION_PROCESSING: `${API_BASE}/api/v1/new-solution/orchestrator/processing/`,
    ANALYZE_FILE: `${API_BASE}/api/v1/new-solution/orchestrator/analyze-file/`,
  },
};
